//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/NXObject.js";
import "../no/ugmath.js";
let d=[[],[[["objectsToCopy"],"Copy",{},1,0],[[],"IsEmpty",{R_:{bIsEmpty:''}},0,0],[["target","nObjectCopies"],"Paste",{R_:{objectCopies:"NXObject[]"}},1,0],[["target","xform","nObjectCopies"],"PasteSpecial",{R_:{objectCopies:"NXObject[]"}},2,0],[[],"Clear",{},0,0],[[],"GetReferencePoint",{R_:{ptMax:''}},0,0]],[]];
SPLM.Mfg.AM.Clipboard = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.Clipboard";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;